module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/BuyReasonSection/buying-process-922a21a136f1ad265c1515a74ee42a2c.png";